'use client';

import { useCallback, useState } from 'react';
import type { Tile } from '@/modules/wordle-6/components';
import { FR_WORDLE_STRINGS } from '@/modules/wordle-6/wordleStrings';

function pick(arr: string[]) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function useWordleFeedback(feedbacks = FR_WORDLE_STRINGS.feedbacks) {
  const [feedback, setFeedback] = useState<string | null | undefined>(null);

  const triggerFeedbackFromRow = useCallback((row: Tile[]) => {
    const correct = row.filter(t => t.state === 'correct').length;
    const present = row.filter(t => t.state === 'present').length;

    let text: string | undefined;

    if (correct === row.length) {
      text = pick(feedbacks.perfect);
    } else if (correct >= 3) {
      text = pick(feedbacks.veryHot);
    } else if (correct >= 1 && present >= 1) {
      text = pick(feedbacks.hot);
    } else if (present >= 1) {
      text = pick(feedbacks.warm);
    } else {
      text = pick(feedbacks.cold);
    }

    setFeedback(text);

    setTimeout(() => setFeedback(null), 1600);
  }, [feedbacks]);

  return {
    feedback,
    triggerFeedbackFromRow,
  };
}
